import React from 'react';
import './ScrappingSection.scss';

const ScrappingSection = ({ scrappingData }) => {
  const steps = [
    {
      id: 1,
      icon: scrappingData?.Step1Image?.value?.src,
      stepNumber: scrappingData?.Step1Heading?.value,
      text: scrappingData?.Step1Text?.value,
    },
    {
      id: 2,
      icon: scrappingData?.Step2Image?.value?.src,
      stepNumber: scrappingData?.Step2Heading?.value,
      text: scrappingData?.Step2Text?.value,
    },
    {
      id: 3,
      icon: scrappingData?.Step3Image?.value?.src,
      stepNumber: scrappingData?.Step3Heading?.value,
      text: scrappingData?.Step3Text?.value,
    },
    {
      id: 4,
      icon: scrappingData?.Step4Image?.value?.src,
      stepNumber: scrappingData?.Step4Heading?.value,
      text: scrappingData?.Step4Text?.value,
    },
    {
      id: 5,
      icon: scrappingData?.Step5Image?.value?.src,
      stepNumber: scrappingData?.Step5Heading?.value,
      text: scrappingData?.Step5Text?.value,
    },
    {
      id: 6,
      icon: scrappingData?.Step6Image?.value?.src,
      stepNumber: scrappingData?.Step6Heading?.value,
      text: scrappingData?.Step6Text?.value,
    },
  ];

  return (
    <section className="scrapping-section">
      <div className="container customContainer">
        <div className="scrapping-header">
          <h2>{scrappingData?.ProcessingHeading?.value || ''}</h2>
        </div>

        <div className="process-flow">
          <div className="process-row top-row">
            {steps.slice(0, 3).map((step) => (
              <div key={step.id} className="process-step">
                <div className="step-icon">
                  {step.icon && <img src={step.icon} alt={`Step ${step.id}`} />}
                </div>
                <div className="step-label">{step.stepNumber || ''}</div>
                <p className="step-text">{step.text || ''}</p>
              </div>
            ))}
          </div>

          <div className="vertical-connector"></div>

          <div className="process-row bottom-row">
            {steps.slice(3, 6).map((step) => (
              <div key={step.id} className="process-step">
                <div className="step-icon">
                  {step.icon && <img src={step.icon} alt={`Step ${step.id}`} />}
                </div>
                <div className="step-label">{step.stepNumber || ''}</div>
                <p className="step-text">{step.text || ''}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScrappingSection;
